import { Directive, HostBinding, HostListener } from '@angular/core';
import { EventUtils } from '../../../utils/event.utils';

@Directive({
  selector: '[hfDragover]'
})
export class DragoverDirective {
  @HostBinding('class.dragover')
  public dragover = false;

  @HostListener('dragover', ['$event'])
  public onDragOver(event: DragEvent) {
    EventUtils.preventDefaultAndStopPropagation(event);
    this.dragover = event.dataTransfer?.types?.includes('Files') ?? true;
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(event: Event) {
    EventUtils.preventDefaultAndStopPropagation(event);
    this.dragover = false;
  }

  @HostListener('drop', ['$event'])
  public onDrop(event: Event) {
    EventUtils.preventDefaultAndStopPropagation(event);
    this.dragover = false;
  }
}
